export default "__VITE_ASSET__iV3IjrSX__"